import { Fraction } from 'bi-fraction';
import { forwardRef } from 'react';

import type { NumProps } from './Num';
import { Percent } from './Percent';

type PercentChangeProps = NumProps;

export const PercentChange = forwardRef<HTMLDivElement, PercentChangeProps>(
  (props, ref) => {
    const value = props.value ? new Fraction(props.value) : null;
    return (
      <Percent
        ref={ref}
        prefix={value?.gte(0) ? '+' : undefined}
        color={value?.gte(0) ? 'state.success' : 'state.error'}
        {...props}
      />
    );
  },
);

PercentChange.displayName = 'PercentChange';
